import {
  TeamOutlined,
  CalendarOutlined
} from "@ant-design/icons";
import { Typography } from "@mui/material";

const icons = {
  TeamOutlined,
  CalendarOutlined
};

const humanResources = {
  id: "human-resources",
  title: (
    <Typography variant="h5" component="div">
      Human Resources
    </Typography>
  ),
  type: "accordion",
  children: [
    {
      id: "birthday",
      title: "Birthdays",
      type: "item",
      url: "/birthday-view",
      icon: icons.TeamOutlined,
    },
      {
      id: "travelCalendar",
      title: "Travel Calendar",
      type: "item",
      url: "/travel-calendar-view",
      icon: icons.CalendarOutlined,
    },
  ],
};

export default humanResources;
